import { render, staticRenderFns } from "./HowToPlay.vue?vue&type=template&id=186a1bc8&scoped=true&"
import script from "./HowToPlay.vue?vue&type=script&lang=js&"
export * from "./HowToPlay.vue?vue&type=script&lang=js&"
import style0 from "./HowToPlay.vue?vue&type=style&index=0&id=186a1bc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186a1bc8",
  null
  
)

export default component.exports